import { render, staticRenderFns } from "./GoTermEnrichment.vue?vue&type=template&id=ba4d02c8&scoped=true"
import script from "./GoTermEnrichment.vue?vue&type=script&lang=js"
export * from "./GoTermEnrichment.vue?vue&type=script&lang=js"
import style0 from "./GoTermEnrichment.vue?vue&type=style&index=0&id=ba4d02c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4d02c8",
  null
  
)

export default component.exports